function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightSearchMatch(text: string, query: string): Array<string | { match: string }> {
  if (!text || !query || !query.trim()) return [text];

  const regex = new RegExp(`(${escapeRegExp(query)})`, 'gi');
  const parts = text.split(regex);
  if (parts.length === 1) return [text];

  return parts.map((part, index) => (index % 2 === 1 ? { match: part } : part));
}
